"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exclamationsFor = exports.heatValue = exports.heatLevel = void 0;
/** The level of a slack in minutes, by the thresholds `[cold, mild, hot, burning]` (120, 60, 15, 0). */
const heatLevel = (slack, [cold, mild, hot, burning]) => {
    if (slack > cold) {
        return 'frio';
    }
    if (slack > mild) {
        return 'templado';
    }
    if (slack > hot) {
        return 'caliente';
    }
    return slack >= burning ? 'ardiente' : 'llamas';
};
exports.heatLevel = heatLevel;
// Minutes past the last threshold until the heat reaches 100, and the scale
// of the cold tail's decay.
const FIRE_SPAN_MIN = 45;
const COLD_DECAY_MIN = 45;
/**
 * The heat of a slack, 0 to 100: continuous and monotonic, so with the clock
 * it only rises, and it falls only on an event (a Play, a Stop, the plan
 * moving). Cold fades from 25 towards 0; mild runs 25–50, hot 50–75,
 * burning 75–90 and on fire 90–100.
 */
const heatValue = (slack, [cold, mild, hot, burning]) => {
    if (slack > cold) {
        return 25 * Math.exp(-(slack - cold) / COLD_DECAY_MIN);
    }
    if (slack > mild) {
        return 50 - (slack - mild) * 25 / (cold - mild);
    }
    if (slack > hot) {
        return 75 - (slack - hot) * 25 / (mild - hot);
    }
    if (slack >= burning) {
        return 90 - (slack - burning) * 15 / (hot - burning);
    }
    return 90 + 10 * Math.min(1, (burning - slack) / FIRE_SPAN_MIN);
};
exports.heatValue = heatValue;
/** The `!` for minutes past a target: 0 to 3 by the thresholds `[one, two, three]`. */
const exclamationsFor = (minutes, [one, two, three]) => {
    if (minutes >= three) {
        return 3;
    }
    if (minutes >= two) {
        return 2;
    }
    return minutes >= one ? 1 : 0;
};
exports.exclamationsFor = exclamationsFor;
//# sourceMappingURL=heat.js.map